<template>
    <div class="list">
        <div class="left_box item">
            <div class="title_box">
                <div class="title">支部动态</div>
                <div class="more" @click="showMoreNews">更多 ></div>
            </div>
            <div class="list_box">
                <div class="list_item" v-for="(item, index) in newsList" :key="index" @click="showNewsDetail( item.news_id )">
                    <img :src="item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1" alt="">
                    <img :src="$ImgUrl + item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1" alt="">
                    <img src="../../assets/static/index/default.png" v-if="!item.news_headpic" alt="">
                    <div class="info_box">
                        <div class="info_title">
                            <span>{{ item.news_title }}</span>
                        </div>
                        <div class="info_content">
                            <span>{{ item.news_content }}</span>
                        </div>
                        <div class="more" @click="showMoreNews">
                            查看更多 >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right_box item">
            <div class="title_box">
                <div class="title">三会一课</div>
                <div class="more" @click="showMoreMeeting">更多 ></div>
            </div>
            <div class="list_box">
                <div class="info_item" v-for="(item, index) in list" :key="index" @click="showMeetingDetail( item.meetingId )">
                    <img src="../../assets/static/index/default.png" alt="">
                    <div class="info_title">
                        {{ item.meetingName }}
                    </div>
                    <div class="dept_name">
                         {{ item.deptName }}
                    </div>
                    <div class="desc_item">
                        <span class="iconfont icon-shijian"></span>
                        <span class="label">时间:  </span>
                        <span>{{ item.startTime }}</span>
                    </div>
                    <div class="desc_item">
                        <span class="iconfont icon-dizhi"></span>
                        <span class="label">地点: </span>
                        <span>{{ item.meetingAddress }}</span>
                    </div>
                    <div class="desc_item">
                        <span class="iconfont icon-renshu"></span>
                        <span class="label">参会人数: </span>
                        <span>{{ item.memberCount }}</span>
                    </div>
                    <div class="desc_status">
                        <div class="status_left">
                            <span class="iconfont icon-yijieshu"></span>
                            <span class="statuc_name">{{ item.meetingStatusName }}</span>
                        </div>
                        <div class="more">
                            查看更多 >
                        </div>
                    </div>
                </div>
            </div>
            <no-more v-if="list.length == 0"></no-more>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
                newsList: []
            }
        },
        props: {
            deptId: Number
        },
        watch: {
            deptId () {
                this.getList()
            }
        },
        mounted() {
            this.getNews()
            this.getList()
        },
        methods: {
            //获取会议列表
            async getList () {
               if ( this.deptId ) {
                    let res = await this.$axios.post("/lencon/pc/activity/three_meeting_list", { deptId: this.deptId, threeMeetingType:0, pageSize: 2 })
                    if ( res.data.code == 1 ) {
                        this.list = res.data.data
                        console.log( this.list )
                    }
               }
            },

            // 查看更多会议
            showMoreMeeting () {
                localStorage.activeIndex = 2
                this.$router.push({
                    path:`/DeptMeeting/meeting/1/${this.deptId}?activeMain=0`,
                })
            },

            // 获取组织动态
            async getNews () {
                let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id: 200, pageSize: 2})
                if ( res.data.code == 1 ) {
                    this.newsList = res.data.res
                }
            },

            // 去喜讯列表
            showMoreNews () {
                this.$router.push({
                    path: "/moreNewsList",
                    query: {
                        cate_id: 200,
                        isSearch: 0,
                        keyword: ""
                    }
                })
            },

            // 查看新闻详情
            showNewsDetail ( id ) {
                this.$router.push({
                    path: `/NewsDetail/${ id }`,
                    query: {
                        cate_id: 200
                    }
                })
            },

            // 会议详情
            showMeetingDetail ( id ) {
                this.$router.push({
                    path: `/MeetingDetail/${ id }`
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.list {
    width: 1200px;
    margin: 20px auto;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .item {
        width: 590px;
        padding: 20px;
        box-sizing: border-box;
        .title_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 10px;
            border-bottom: 1px solid #2767c4 ;
            .title {
                font-size: 24px;
                color: #2767c4 ; 
                font-weight: bold;
                
            }
            .more {
                font-size: 14px;
                color: #B3B3B3;
                cursor: pointer;
            }
        }
        .list_box {
            margin-top: 20px;
            cursor: pointer;
        }
    }
    .left_box {
        width: 590px;
        box-sizing: border-box;
        .list_box {
            width: 100%;
            .list_item {
                width: 100%;
                display: flex;
                margin:  20px 0;
                padding: 20px 0;
                box-sizing: border-box;
                img {
                    width: 255px;
                    height: 153px;
                }
                .info_box {
                    margin-left: 20px;
                    flex: 1;
                    overflow: hidden;
                    .info_title {
                        width: 100%;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 30px;
                        @include SingleRow;
                        span {
                            @include SingleRow;
                        }
                    }
                    .info_content {
                        font-size: 16px;
                        color: #828181;
                        padding: 10px 0;
                        height: 100px;
                        span {
                            @include MultipleRows(4);
                        }
                    }
                    .more {
                        font-size: 14px;
                        color: #828181;
                    }
                }
            }
        }
    }

    .right_box {
        .list_box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .info_item {
                width: 265px;
                img {
                    width: 265px;
                    height: 188px;
                }
                .info_title {
                    font-size: 18px;
                    font-weight: bold;
                    @include SingleRow;
                    padding: 10px;
                }
                .dept_name {
                    padding: 10px;
                    font-size: 16px;
                    color: #828181;
                    @include SingleRow;
                }
                .desc_item {
                    color: #8E8E8E;
                    font-size: 14px;
                    padding: 5px 10px;
                    .iconfont {
                        margin-right: 10px;
                    }
                }
                .desc_status {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 5px 10px;
                    .status_left {
                        font-weight: bold;
                        color: #2767c4 ;
                        .iconfont {
                            margin-right: 5px;
                        }
                    }
                    .more {
                        color: #8E8E8E;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>